module.exports = "/assets/data/7a75512d05bfc82c4b44adfc4b88a9f2-WA6.data.json";